import { type FC, useContext } from 'react';
import { graphql, useFragment } from 'react-relay';

import { GetHelpZendeskGroupTopicLink } from './getHelpZendeskTopicGroups/GetHelpZendeskGroupTopicLink.tsx';
import { GetHelpZendeskTopicsGroup } from './getHelpZendeskTopicGroups/GetHelpZendeskTopicsGroup.tsx';

import { GetHelpZendeskContext } from './GetHelpZendeskContext.ts';
import { ACTIONS, STEPS } from './GetHelpZendeskConstants.ts';

import { type GetHelpZendeskCommonQuestions_viewer$key } from './__generated__/GetHelpZendeskCommonQuestions_viewer.graphql.ts';

const viewerFragment = graphql`
    fragment GetHelpZendeskCommonQuestions_viewer on Viewer {
        getHelpCmsTopics {
            groupLabel
            topics {
                topicKey
                topicLabel
            }
        }
    }
`;

const GetHelpZendeskCommonQuestions: FC<{ viewer: GetHelpZendeskCommonQuestions_viewer$key }> = ({
    viewer: viewerRef,
}) => {
    const { dispatch } = useContext(GetHelpZendeskContext);
    const viewer = useFragment(viewerFragment, viewerRef);
    const { getHelpCmsTopics } = viewer;

    return (
        <>
            {getHelpCmsTopics?.map(topic => {
                const { groupLabel, topics } = topic || {};

                return (
                    <GetHelpZendeskTopicsGroup key={groupLabel} groupLabel={groupLabel || ''}>
                        {topics?.map(topic => (
                            <GetHelpZendeskGroupTopicLink
                                key={topic?.topicKey}
                                onClick={() => {
                                    dispatch({ type: ACTIONS.SET_STEP, step: STEPS.CMS_TOPIC });
                                    dispatch({
                                        type: ACTIONS.SET_CMS_TOPIC_KEY,
                                        topicKey: topic?.topicKey || '',
                                    });
                                }}
                            >
                                {topic?.topicLabel}
                            </GetHelpZendeskGroupTopicLink>
                        ))}
                    </GetHelpZendeskTopicsGroup>
                );
            })}
        </>
    );
};

export { GetHelpZendeskCommonQuestions };
